import React from 'react';
import { Box, Container, Divider, Typography, Link, useTheme } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

function Footer() {
  const theme = useTheme();

  return (
    <Box
      sx={{
        bgcolor: theme.palette.primary.main,
        color: 'white',
        py: 3, // Reduced padding from 6 to 3
        mt: 'auto',
        backgroundImage: 'linear-gradient(to right, #121B33, #1C2B4F)',
      }}
    >
      <Container maxWidth="lg">
        <Divider sx={{ mb: 2, borderColor: 'rgba(255,255,255,0.1)' }} />  {/* Reduced margin from 4 to 2 */}
        <Box sx={{
          display: 'flex',
          justifyContent: 'space-between',
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: 'center',
          py: 1
        }}>
          {/* Copyright */}
          <Box sx={{ textAlign: 'center', py: { xs: 2, sm: 2 } }}>
            <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.7)' }}>
              © {new Date().getFullYear()} WorldWise Scholar. All rights reserved.
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', gap: 2, mt: { xs: 1, sm: 0 } }}> {/* Reduced top margin from 2 to 1 on mobile */}
            <Link
              component={RouterLink}
              to="/privacy"
              variant="body2"
              color="rgba(255,255,255,0.8)"
              sx={{
                textDecoration: 'none',
                cursor: 'pointer',
                '&:hover': {
                  color: theme.palette.secondary.main,
                  textDecoration: 'none',
                }
              }}
            >
              Privacy Policy
            </Link>
            <Link
              component={RouterLink}
              to="/terms"
              variant="body2"
              color="rgba(255,255,255,0.8)"
              sx={{
                textDecoration: 'none',
                cursor: 'pointer',
                '&:hover': {
                  color: theme.palette.secondary.main,
                  textDecoration: 'none',
                }
              }}
            >
              Terms of Service
            </Link>
            <Link
              component={RouterLink}
              to="/contact"
              variant="body2"
              color="rgba(255,255,255,0.8)"
              sx={{
                textDecoration: 'none',
                cursor: 'pointer',
                '&:hover': {
                  color: theme.palette.secondary.main,
                  textDecoration: 'none',
                }
              }}
            >
              Contact
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

export default Footer; 